/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ScanFrameIcon24Regular = forwardRef('ScanFrameIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M21.75 6A3.75 3.75 0 0 0 18 2.25h-2.25a.75.75 0 0 0 0 1.5H18A2.25 2.25 0 0 1 20.25 6v2.25a.75.75 0 0 0 1.5 0V6Z" }),
        React.createElement("path", { d: "M6 21.75A3.75 3.75 0 0 1 2.25 18v-2.25a.75.75 0 0 1 1.5 0V18A2.25 2.25 0 0 0 6 20.25h2.25a.75.75 0 0 1 0 1.5H6Z" }),
        React.createElement("path", { d: "M18 21.75A3.75 3.75 0 0 0 21.75 18v-2.25a.75.75 0 0 0-1.5 0V18A2.25 2.25 0 0 1 18 20.25h-2.25a.75.75 0 0 0 0 1.5H18Z" }),
        React.createElement("path", { d: "M6 2.25A3.75 3.75 0 0 0 2.25 6v2.25a.75.75 0 0 0 1.5 0V6A2.25 2.25 0 0 1 6 3.75h2.25a.75.75 0 0 0 0-1.5H6Z" })));
});
